import type { LucideIcon } from 'lucide-react';
import {
  Activity,
  BarChart3,
  BookOpen,
  Building2,
  Calendar,
  Crown,
  FlaskConical,
  Globe,
  LayoutDashboard,
  Lightbulb,
  MessageCircle,
  PieChart,
  TrendingUp,
} from 'lucide-react';

export interface ChatStarterPrompt {
  prompt: string;
  icon: LucideIcon;
}

export const CHAT_STARTER_PROMPTS: ChatStarterPrompt[] = [
  {
    prompt: 'Tell me about different option-based strategies.',
    icon: BookOpen,
  },
  {
    prompt: 'Can you please create a chart for TSLA for me?',
    icon: BarChart3,
  },
  {
    prompt: 'Can you backtest a long ATM straddle that expires in 1 week with 50 delta on NVDA for the past 5 years?',
    icon: FlaskConical,
  },
  {
    prompt: 'How did Google perform in its last earnings result?',
    icon: Building2,
  },
  {
    prompt: 'What happened with gold yesterday?',
    icon: Crown,
  },
  {
    prompt: 'Can you tell me the correlation between gold and the market over the past 3 years?',
    icon: PieChart,
  },
  {
    prompt: 'Please chart the 5-day and 10-day moving averages for me.',
    icon: Activity,
  },
  {
    prompt: 'Provide me with the beta for AAPL relative to SPY since 2020.',
    icon: BarChart3,
  },
  {
    prompt: 'Does SMH offer a higher Sharpe ratio compared to SPY?',
    icon: TrendingUp,
  },
  {
    prompt: 'Can you provide me with some geopolitical insights related to markets in 2025?',
    icon: Globe,
  },
  {
    prompt: 'Can you create an RSI chart for First Solar?',
    icon: Activity,
  },
  {
    prompt: 'What was the maximum monthly return offered by the market?',
    icon: Calendar,
  },
  {
    prompt: 'Can you compare the 1-day returns offered by different assets?',
    icon: LayoutDashboard,
  },
  {
    prompt: 'Can you help me backtest covered calls on META, where I short a 20-delta call every week expiring in 7 days?',
    icon: FlaskConical,
  },
  {
    prompt: 'What has been the risk-adjusted return for Salesforce since COVID?',
    icon: TrendingUp,
  },
  {
    prompt: 'What option strategy should I use if I am moderately bullish on Netflix, and can this be backtested as well?',
    icon: Lightbulb,
  },
];
